import parse from 'utils/parse';
import happen from 'utils/happen';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'summer-contest-banner', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
  joinButton: makeTestId('join-button'),
});

const summerContestBannerStartDate = '2025-07-21T12:00:00+02:00';
const summerContestBannerEndDate = '2025-09-01T23:59:59+02:00';

const summerContestStartDate = '2025-07-28T00:00:00+02:00';
const summerContestEndDate = summerContestBannerEndDate;

const contestPrize = 250_000;

/**
 * Checks if the summer contest banner is currently active based on the defined start and end dates
 * @returns boolean indicating if the banner is currently active
 */
const isSummerContestBannerActive = (now = new Date()): boolean => {
  return happen(now).between(
    new Date(summerContestBannerStartDate).getTime(),
    new Date(summerContestBannerEndDate).getTime()
  );
};

export {
  summerContestBannerStartDate,
  summerContestBannerEndDate,
  summerContestStartDate,
  summerContestEndDate,
  isSummerContestBannerActive,
  contestPrize,
  testId,
};
